import React from 'react';
import CertificationForm from './CertificationForm';
import Stack from 'components/common/Stack';
import { trackComponent } from 'telemetry/AppInsights';

const NewCertificationPage = props => {
  const handleSubmit = response => {
    props.history.push(`/certifications/${response.id}`);
  };

  const handleCancel = () => {
    props.history.push('/certifications');
  };

  return (
    <Stack>
      <CertificationForm isCreateMode onSubmit={handleSubmit} onCancel={handleCancel} />
    </Stack>
  );
};

export default trackComponent(NewCertificationPage, 'New Certification Page');
